import React from 'react';
import ReactDOM from 'react-dom';
import 'share-api-polyfill';
import axios from 'axios';

import './index.css';
import './styles/responsive.css';
import './styles/style.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import * as serviceWorker from './serviceWorker';
import Providers from './Providers';
import 'react-toastify/dist/ReactToastify.css';


// if (process.env.NODE_ENV === 'development') {
//   const proxyurl = 'https://cors-anywhere.herokuapp.com';
//   axios.interceptors.request.use((config) => ({
//     ...config,
//     url: `${proxyurl}/${config.url}`,
//   }));
// }

// ReactDOM.render(<Providers />, document.getElementById('react-app-root'));
const rootElement = document.getElementById("react-app-root");
if (rootElement) {
    if (rootElement.hasChildNodes()) {
        ReactDOM.hydrate(<Providers />, rootElement.firstElementChild);
    } else {
        ReactDOM.render(<Providers />, rootElement);
    }
}
serviceWorker.unregister();
